<template>
  <div class="look-video" v-if="videoList.length>0">
    <div class="title">
      <img
        class="pc-title"
        src="https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-title5.png"
        alt
      />
      <img
        class="m-title"
        src="https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-title5.png"
        alt
      />
    </div>
    <div class="box">
      <div class="video-box" id="video-box">
        <div class="inner-video">
          <div class="video-detail" :id="`video${videoIndex}`" @click="videoClick"></div>
        </div>
      </div>
      <div class="bottom">
        <span id="video-text"></span>
      </div>
      <div
        id="look-video-prev"
        :class="prevStatus?'disable':''"
        v-if="videoList.length>=2"
        @click="changeVideo('prev')"
      ></div>
      <div
        id="look-video-next"
        :class="nextStatus?'disable':''"
        v-if="videoList.length>=2"
        @click="changeVideo('next')"
      ></div>
    </div>
  </div>
</template>
<script>
import XHR from '../api'

import 'swiper/dist/css/swiper.css'
export default {
  name: 'LookVideo',
  props: [],
  data: () => ({
    videoIndex: 0,
    videoList: [],
    prevStatus: false,
    nextStatus: false
  }),
  components: {

  },
  created () {
  },
  mounted () {
    this.getVideoList()
  },
  methods: {
    // 视频埋点点击
    videoClick (e) {
      if (e.target.id === 'replaybtn') {
        this.sendAnalytics('陕汽德龙X3000专题活动', '精彩视频-播放视频', document.getElementById('video-text').innerHTML)
      }
    },
    changeVideo (type) {
      if (type === 'prev') {
        this.videoIndex--
        if (this.videoIndex === 0) {
          this.prevStatus = true
          this.nextStatus = false
        } else {
          this.prevStatus = false
          this.nextStatus = false
        }
      } else {
        this.videoIndex++
        if (this.videoIndex === this.videoList.length - 1) {
          this.prevStatus = false
          this.nextStatus = true
        } else {
          this.prevStatus = false
          this.nextStatus = false
        }
      }
      this.playVideo(this.videoList, this.videoIndex, '#video-text')
    },
    getVideoList () {
      XHR.getVideoList().then((res) => {
        const { status, data } = res.data
        if (status === 0) {
          this.videoList = data
          this.prevStatus = true
          this.nextStatus = false
          this.$nextTick(() => {
            this.playVideo(data, this.videoIndex, '#video-text')
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="less" scoped>
.look-video {
  margin-top: 78px;
}
.title {
  .pc-title {
    display: none;
  }
  .m-title {
    margin: 0 auto;
    display: block;
    width: 300px;
  }
}
.box {
  position: relative;
  margin: 0 auto;
  background-size: cover;
  background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-box5.png");
  width: 540px;
  height: 442px;
  padding: 23px 3px 3px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .video-box {
    height: 300px;
    background: #000000;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-left-radius: 40px;
    border-top-right-radius: 40px;
    .inner-video {
      width: 508px;
      height: 283px;
    }
    .video-detail {
      height: 100%;
      width: 100%;
      video {
        border-radius: 40px;
      }
    }
  }
  .bottom {
    background-color: rgba(0, 0, 0, 0.8);
    height: 115px;
    border-bottom-left-radius: 40px;
    border-bottom-right-radius: 40px;
    font-size: 32px;
    color: rgb(255, 255, 255);
    text-align: center;
    z-index: 100;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      overflow: hidden;
      text-overflow: -o-ellipsis-lastline;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  #look-video-prev {
    position: absolute;
    left: -80px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    background-size: cover;
    background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-left.png");
    width: 60px;
    height: 100px;
    cursor: pointer;
    &.disable {
      opacity: 0.35;
      cursor: auto;
      pointer-events: none;
    }
  }
  #look-video-next {
    position: absolute;
    right: -80px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    background-size: cover;
    background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-right.png");
    width: 60px;
    height: 100px;
    cursor: pointer;
    &.disable {
      opacity: 0.35;
      cursor: auto;
      pointer-events: none;
    }
  }
}
@media screen and (min-width: 751px) {
  .title {
    .pc-title {
      margin: 0 auto;
      display: block;
      width: 380px;
    }
    .m-title {
      display: none;
    }
  }
  .box {
    background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-box5.png");
    width: 864px;
    height: 589px;
    .video-box {
      height: 480px;
      .inner-video {
        width: 826px;
        height: 464px;
      }
      #video {
        height: 100%;
        width: 100%;
        .ccH5Poster {
          border-radius: 40px;
        }
        video {
          border-radius: 40px;
        }
      }
    }
    .bottom {
      background-color: rgba(0, 0, 0, 0.8);
      height: 83px;
      line-height: 83px;
      border-bottom-left-radius: 40px;
      border-bottom-right-radius: 40px;
      font-size: 32px;
      color: rgb(255, 255, 255);
      z-index: 100;
      text-align: center;
      padding: 0 20px;
      span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
      }
    }
    #look-video-prev {
      position: absolute;
      left: -100px;
      top: 0;
      bottom: 0;
      margin: auto 0;
      background-size: cover;
      background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-left.png");
      width: 80px;
      height: 100px;
      cursor: pointer;
      &.disable {
        opacity: 0.35;
        cursor: auto;
        pointer-events: none;
      }
    }
    #look-video-next {
      position: absolute;
      right: -100px;
      top: 0;
      bottom: 0;
      margin: auto 0;
      background-size: cover;
      background-image: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/pc/pc-right.png");
      width: 80px;
      height: 100px;
      cursor: pointer;
      &.disable {
        opacity: 0.35;
        cursor: auto;
        pointer-events: none;
      }
    }
  }
}
.ccH5PlayBtn {
  background: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-play.png")
    no-repeat !important;
}
#replaybtn {
  background: url("https://s-test.kcimg.cn/topic/images/shanqi-truck/m/m-play.png")
    no-repeat !important;
}
</style>
